<template>
  <Modal
    @modalClose="onCloseModal">
    <div class="modal-header">
      <slot name="header-title" v-if="$slots['header-title']"></slot>
      <h5 v-if="!$slots['header-title']">เลือกภาพ</h5>
      <button
        @click="onCloseModal"
        class="btn btn-link btm-sm btn-close-container">
        <i class="fas fa-times"></i>
      </button>
    </div>
    <div class="modal-body">
      <div class="alert alert-danger" v-if="isShowMessageError">
        <strong>มีข้อผิดพลาดเกิดขึ้น</strong>
        <ul class="error-container">
          <li
            v-for="(error, errorIndex) in fileValidError"
            :key="errorIndex">{{error}}</li>
          <li
             v-for="(uploadError, uploadErrorIndex) in uploadPdfStateError.data"
            :key="uploadErrorIndex">{{uploadError}}</li>
        </ul>
        <div class="error-container" v-if="!fileValidError">
          Code : {{uploadPdfStateError.statusCode}} ({{uploadPdfStateError.status || 'not found' }})
        </div>
      </div>
      <div :class="{'tab-item-container tab-item-general': !previewPdf}" v-if="selectedTabIndex === 0">
        <div class="upload-file-container"
          :class="{'browse-file': !previewPdf}">
          <!-- select Image -->
          <EmptyMessage v-if="!previewPdf">
            <input
              @change="fileBrowsed"
              type="file"
              ref="file"
              class="input-file"
              accept="application/pdf">
            <span slot="icon" class="icon">
              <i class="fas fa-cloud-upload-alt"></i>
            </span>
            <div class="title">ลากไฟล์หรือคลิกเพื่ออัปโหลด</div>
          </EmptyMessage>
          <div
            v-if="previewPdf">
            <div class="file-info">
              <div class="info--icon">
                <i class="fas fa-file-pdf"></i>
              </div>
            <div class="info--meta">
              <div class="title">{{pdfName}}</div>
            </div>
              <button
                type="button"
                class="btn btn-light btn-action"
                @click.stop="onRemovePreview">
                <i class="far fa-trash-alt"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button
        type="button"
        class="btn btn-link btn-remove"
        @click.stop="onRemovePreview"
        v-if="previewPdf">
        <i class="fas fa-angle-left icon"></i> เลือกใหม่
      </button>
      <button
        type="button"
        class="btn btn-primary"
        @click.stop="onSubmit"
        :disabled="!isValid">
        <slot name="button-submit" v-if="$slots['button-submit']"></slot>
        <span v-if="!$slots['header-title']">ใช้เป็นภาพปก</span>
      </button>
    </div>
  </Modal>
</template>

<script>
import _ from 'lodash';
import { axiosImageAPI } from '@/axios';
import Modal from '@/components/Modal.vue';
import EmptyMessage from '@/components/EmptyMessage.vue';

export default {
  props: {
    fileType: {
      type: String,
      default: 'pdf',
    },
    pdfObject: {
      type: Object,
      default: () => {},
    },
    onCloseModal: {
      type: Function,
      default: () => {},
    },
  },
  components: {
    Modal,
    EmptyMessage,
  },
  data() {
    return {
      selectedTabIndex: 0,
      previewPdf: null,
      pdfName: null,
      postPdf: null,
      uploadPdfStateError: [],
      fileValidError: [],
      maxFileSize: 20 * 1024 * 2014,
      isUploadingPdf: false,
    };
  },
  computed: {
    isValid() {
      if (!this.previewPdf) {
        return false;
      }

      return _.isEmpty(this.fileValidError) && _.isEmpty(this.uploadPdfStateError);
    },
    isShowMessageError() {
      return !_.isEmpty(this.fileValidError) || !_.isEmpty(this.uploadPdfStateError);
    },
  },
  methods: {
    getErrorCode() {
      return _.get(this.uploadPdfStateError, 'status', null);
    },
    async uploadFile(pdf) {
      this.isUploadingPdf = true;
      try {
        const uploadPdf = (file) => {
          const formData = new FormData();
          formData.append('file', file);
          return axiosImageAPI.post('/files', formData, {
            headers: { 'content-type': 'multipart/form-data' },
          });
        };
        const response = await uploadPdf(pdf);
        this.previewPdf = response.data;
        const pathIndex = this.previewPdf.baseUrl.search('/files');
        this.postPdf = {
          name: pdf.name,
          format: this.previewPdf.type,
          url: this.previewPdf.baseUrl,
          path: this.previewPdf.baseUrl.slice(pathIndex),
        };
        this.isUploadingPdf = false;
        this.uploadPdfStateError = null;
      } catch (error) {
        this.isUploadingPdf = false;
        this.uploadPdfStateError = error.response.data;
      }
    },
    onSubmit() {
      this.$emit('update:pdfObject', this.postPdf);
    },
    onRemovePreview() {
      this.previewPdf = null;
    },
    isValidFile(file) {
      this.fileValidError = [];

      if (!file.type.match('pdf.*')) {
        this.fileValidError.push(`ไฟล์ ${file.name} ไม่ใช่ไฟล์ pdf`);
        return false;
      }
      if (file.size > this.maxFileSize) {
        this.fileValidError.push(`ไฟล์ ${file.name} มีขนาดใหญ่กว่า 20 MB`);
        return false;
      }

      return true;
    },
    fileBrowsed() {
      const filePdf = this.$refs.file.files[0];
      this.pdfName = filePdf.name;
      if (this.isValidFile(filePdf)) {
        this.uploadFile(filePdf);
      }
    },
    isShowingTabMenu() {
      return !_.isEmpty(this.tabMenu) && !_.isEmpty(this.imageOptions);
    },
    selectedTab(selectedTabIndex) {
      // reset preview image
      if (this.selectedTabIndex !== 0 && this.previewPdf) {
        this.previewPdf = null;
      }
      this.selectedTabIndex = selectedTabIndex;
    },
  },
};
</script>

<style lang="scss" scoped>
@import './src/assets/scss/variables.scss';

.tab-item-container {
  min-height: 300px;
  max-height: 50vh;
}

.upload-file-container {
  position: relative;

  &.browse-file {
    border: 2px dashed $gray-200;
    cursor: pointer;
    transition: all 0.2s ease-out;

    &:hover {
      background-color: $gray-100;
    }
  }
}

.input-file {
  opacity: 0;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  z-index: 100;
  cursor: pointer;
}

.error-container {
  margin-bottom: 0;
  margin-top: $spacer * 0.5;
  padding-left: $spacer;
}

.image-container {
  background-color: $gray-700;
  position: relative;

  .action {
    position: absolute;
    top: $spacer * 0.5;
    right: 0;
    z-index: 101;
  }
}

.image-options-container {
  display: flex;
  flex-wrap: wrap;

  .image-item-container {
    flex: 0 0 calc(33.33% - 12px);
    height: auto;
    margin-right: $spacer;
    margin-bottom: $spacer;
    cursor: pointer;
    position: relative;
    border: 2px solid transparent;

    .image-item-overlay {
      opacity: 0;
      background-color: rgba(0, 0, 0, 0.5);

      display: flex;
      align-items: center;
      justify-content: center;
      color: white;

      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;

      z-index: 102;

      transition: all 0.2s ease-out;
    }

    &.is-selected {
      border: 2px solid $primary;
    }

    &:nth-child(3n+0) {
      margin-right: 0;
    }

    &:hover {
      .image-item-overlay {
        opacity: 1;
      }
    }
  }
}

.file-info{
  display: flex;
  flex-flow: row;
  padding: 10px 2px;
  transition: background 250ms ease;
  .info--icon{
    width: 50px;
    display:flex;
    justify-content: center;
    align-items: center;

    i{
      font-size: 42px;
    }
  }

  .info--meta{
    display: flex;
    align-items: center;
    flex-grow: column;
    flex: 1;

    .title {
      color: $gray-700;
      font-weight: bold;
    }
  }
}
</style>
